<template>
    <div class="uk-section uk-section-small">
        <div class="uk-container">
            <h2 class="uk-heading-bullet">{{ p_date.date }}</h2>
            <div class="uk-grid-small" uk-grid uk-lightbox>
                <Photo v-for="photo in p_date.photos" v-bind:key="photo.id" v-bind:photo="photo"></Photo>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs'
import Photo from './Photo'

export default {
    name: 'photoBlock',
    components: {
        Photo
    },
    props: {
        p_date: Object,
    },
    data: function () {
        return {
            // date: this.p_date.date,
            // photos: {}
        }
    },
    methods: {
    },
    mounted () {
        /*
        this.$axios.post(
            this.$config.common.apiPath + '/getPhotos/',
            qs.stringify({'date': this.date})
        )
        .then(response => {
            this.photos = response.data
        })
        .catch( function(error){

        })
        */
    }
}
</script>

<style>
</style>
